import { ICampaignVote, ICategoryVote, ITemplateChart } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { AI_MODEL_OPTIONS, CAMPAIGN_TYPE, COLORS_STATUS_CAMPAIGN, ENUM_SCHEDULE, SCHEDULE_OPTIONS, SCHEDULE_VOTE_OPTIONS, SCHEDULE_WEEKLY_OPTIONS, STATUS_CAMPAIGN_OPTIONS, VOTE_CYCLE_TYPE } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allTemplateChart, allCategoryVote, allBodyVote, allSubjectVote, deleteMultiCampaignVote, getAllPartners, getCampaignVotes as onGetCampaignVotes, postCreateNewsOfCampaign, putStatusCampaignVote } from "../../../store/thunks";
import CampaignForm from './CampaignForm';
import DropdownCategoryVote from 'components/Common/DropdownCategoryVote';
import { filterMediaOptions } from 'helpers/format';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const CampaignList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const STATUS_CAMPAIGN_OPTIONS_LANG: any = STATUS_CAMPAIGN_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const AI_MODEL_OPTIONS_LANG: any = AI_MODEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_OPTIONS_LANG: any = SCHEDULE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_VOTE_OPTIONS_LANG: any = SCHEDULE_VOTE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_WEEKLY_OPTIONS_LANG: any = SCHEDULE_WEEKLY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        is_active: withDefault(StringParam, ''),
        type: withDefault(StringParam, `${CAMPAIGN_TYPE.VOTE}`),
        title_template_id: withDefault(StringParam, ''),
        body_template_id: withDefault(StringParam, ''),
        media_id: withDefault(StringParam, ''),
        cycle_type: withDefault(StringParam, ''),
        name: withDefault(StringParam, ''),
        dc_trend_category_id: withDefault(StringParam, ''),
    });

    const [sources, setSources] = useState<{ label: string, value: string, name: string }[]>([]);

    const [partners, setPartners] = useState<{ label: string, value: string, name: string }[]>([]);

    const [templateSubject, setTemplateSubject] = useState<{ label: string, value: string }[]>([]);

    const [templateBody, setTemplateBody] = useState<{ label: string, value: string }[]>([]);

    const [templateChart, setTemplateChart] = useState<ITemplateChart[]>([]);

    const [categoryVote, setCategoryVote] = useState<ICategoryVote[]>([]);

    const [campaignNameSearch, setCampaignNameSearch] = useState<string>(query?.name || "");

    const [cycleTypeSearch, setCycleTypeSearch] = useState<Option | null>(SCHEDULE_VOTE_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.cycle_type)) || null);

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_CAMPAIGN_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_active)) || null);

    const [templateSubjectSearch, setTemplateSubjectSearch] = useState<Option | null>(templateSubject?.find((item) => String(item?.value) === String(query?.title_template_id)) || null);

    const [templateBodySearch, setTemplateBodySearch] = useState<Option | null>(templateBody?.find((item) => String(item?.value) === String(query?.body_template_id)) || null);

    const [categorySearch, setCategorySearch] = useState<Option | null>(null);

    const [mediaSearch, setMediaSearch] = useState<Option | null>(partners?.find((item) => String(item?.value) === String(query?.media_id)) || null);

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [campaignDetail, setCampaignDetail] = useState<ICampaignVote | null>(null);

    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [idAutoPublishLoading, setIdAutoPublishLoading] = useState<string | number | null>(null);

    const [isShowPrompt, setIsShowPrompt] = useState<boolean>(false);
    const [promptShow, setPromptShow] = useState<string>('');

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Campaign;

    const CampaignProperties = createSelector(
        selectLayoutState,
        (state) => ({
            campaignVotes: state.campaignVotes,
            isCampaignVoteSuccess: state.isCampaignVoteSuccess,
            isCampaignVoteLoading: state.isCampaignVoteLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { campaignVotes, error, isCampaignVoteLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetCampaignVotes(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            name: campaignNameSearch || '',
            cycle_type: cycleTypeSearch?.value,
            title_template_id: templateSubjectSearch?.value || '',
            body_template_id: templateBodySearch?.value || '',
            dc_trend_category_id: categorySearch?.value || '',
            media_id: mediaSearch?.value || '',
            is_active: statusSearch?.value ?? '',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            name: '',
            cycle_type: '',
            title_template_id: '',
            body_template_id: '',
            dc_trend_category_id: '',
            media_id: '',
            is_active: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setCampaignNameSearch('');
        setCycleTypeSearch((_prev) => null);
        setCategorySearch((_prev) => null);
        setMediaSearch((_prev) => null);
        setStatusSearch(null);
        setTemplateSubjectSearch((_prev) => null);
        setTemplateBodySearch((_prev) => null);
        setDateSearch([queryNew?.start_date ? moment(queryNew?.start_date || "", 'Y-MM-DD').toDate() : null, queryNew?.end_date ? moment(queryNew?.end_date || "", 'Y-MM-DD').toDate() : null]);
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
        if (type === 'REFRESH_MEDIA') {
            const [res1]: any = await Promise.all([getAllPartners({})]);
            const _list_partner = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
            setPartners((_prev: any) => _list_partner);
        }
    }
    //End::Update

    const handleSetCampaignDetail = (detail: ICampaignVote | null) => {
        setCampaignDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetCampaignDetail(null);
    }

    const handleShowPrompt = (_prompt: string = '') => {
        setPromptShow((_prev) => _prompt);
        setIsShowPrompt((_prev) => true);
    }

    // Begin::Delete

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<ICampaignVote | null>(null);

    const handleConfirmDelete = (item: ICampaignVote) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteMultiCampaignVote({ ids: [initialValuesDefault?.id] });
            if (response?.code === 200) {
                dispatch(onGetCampaignVotes(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    const handleUpdateCampaign = async (dataSubmit: { id: string | number, is_active: number } | undefined = undefined) => {
        try {
            if (!dataSubmit) {
                return;
            }
            setIdLoading((_prev) => (dataSubmit?.id) as string);
            const data = {
                is_active: Number(dataSubmit?.is_active),
            };
            const response: any = await putStatusCampaignVote((dataSubmit?.id) as string, data);
            if (response?.code === 200) {
                setIdLoading((_prev) => null);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh();
            } else {
                setIdLoading((_prev) => null);
                toast(`${response?.message || response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIdLoading((_prev) => null);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const [idCampaignCreateNewsLoading, setIdCampaignCreateNewsLoading] = useState<null | number>(null);
    const handleCreateNews = async (item: ICampaignVote | null) => {
        try {
            if (!item?.id || !!idCampaignCreateNewsLoading) {
                return;
            }
            setIdCampaignCreateNewsLoading((_prev) => item?.id);
            const response: any = await postCreateNewsOfCampaign(item?.id);
            setIdCampaignCreateNewsLoading((_prev) => null);
            if (response?.code === 200) {
                dispatch(onGetCampaignVotes(query));
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIdCampaignCreateNewsLoading((_prev) => null);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };


    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 60,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '40px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('Active Action'),
                accessor: "is_active",
                filterable: false,
                sortable: false,
                thClass: 'text-center align-middle',
                thWidth: 100,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    const active = item?.is_active;
                    return (
                        <div className="text-center form-check form-switch form-switch-sm position-relative" dir="ltr" style={{ minWidth: '80px' }}>
                            {(String(idLoading) === String(item?.id)) && <span className="position-absolute" style={{ top: '3px', left: 0 }}><Spinner size="sm" className="text-primary" /></span>}
                            <input type="checkbox" className="form-check-input" name="status" id="customSwitchsizelg" checked={Boolean(active)}
                                onChange={(event: any) => {
                                    if (isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions)) {
                                        handleUpdateCampaign(
                                            { id: item?.id, is_active: event.target.checked }
                                        );
                                    }
                                }}
                            />
                        </div>
                    );
                }
            },
            {
                Header: t('Name'),
                accessor: "name",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-wrap ">
                            {item?.name || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Boosting Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '140px' }} className="d-flex flex-wrap ">
                            {item?.keyword?.keyword || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Category'),
                accessor: "categories",
                filterable: true,
                sortable: false,
                thWidth: 220,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '190px' }} className="d-flex flex-column flex-wrap ">
                            {(item?.categories || [])?.map((_c: any) => (
                                <div key={_c?.category_id}>{_c?.groups?.[0]?.title ? `${_c?.groups?.[0]?.title || ''} > ` : ''} {_c?.title || '-'} </div>
                            ))}
                            {(item?.categories || [])?.length === 0 && <>-</>}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Media'),
                accessor: "medias",
                filterable: true,
                sortable: false,
                thWidth: 180,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '150px' }} className="d-flex flex-column gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex">
                                    <span>
                                        {_m?.media_name || '-'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Section'),
                accessor: "section",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-column gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex">
                                    <span>
                                        {_m?.media_code?.section_title || '-'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Reporter ID'),
                accessor: "reporters",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-column gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex">
                                    <span>
                                        {_m?.media_reporter_id || '-'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Byline'),
                accessor: "byline",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-column gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex">
                                    <span>
                                        {_m?.reporter_by_line || '-'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Subject Template'),
                accessor: "title_template",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }}>
                            <span>{item?.title_template?.name || '-'}</span>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Body Template'),
                accessor: "body_template",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }}>
                            <span>{item?.body_template?.name || '-'}</span>
                        </div>
                    </>)
                },
            },
            // {
            //     Header: t('Source'),
            //     accessor: "gold_price_sources",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 130,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '110px' }} className="d-flex flex-wrap gap-2">
            //                 {item?.gold_price_sources?.length ? <> {(item?.gold_price_sources || [])?.map((s: any) => (
            //                     <span className="me-1 rounded-pill badge bg-primary-subtle text-primary fs-12" key={s?.id}>{s?.name || ''}</span>
            //                 ))}</> : <>-</>}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('Voting Target'),
                accessor: "cycle_type",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _cycle_type = SCHEDULE_VOTE_OPTIONS_LANG?.find((_v: any) => (String(item?.cycle_type) === String(_v?.value)))?.label || '';
                    return (<>
                        <div style={{ minWidth: '90px' }} className="text-center">
                            <span>{_cycle_type || '-'}</span>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Schedule'),
                accessor: "campaign_schedules",
                filterable: true,
                sortable: false,
                thWidth: 180,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _times = (item?.campaign_schedules || [])?.map((_s: any) => ({
                        schedule: SCHEDULE_OPTIONS_LANG?.find((_v: any) => (String(_s?.type) === String(_v?.value)))?.label || '',
                        date: String(_s?.type) === ENUM_SCHEDULE.EVERY_DAY ? '' : (SCHEDULE_WEEKLY_OPTIONS_LANG?.find((_v: any) => (String(_s?.day_of_week) === String(_v?.value)))?.label || ''),
                        time: (`${String(_s?.time || '')?.split(':')[0] || ''}:${String(_s?.time || '')?.split(':')[1] || ''}`),
                    }));
                    return (<>
                        <div style={{ minWidth: '150px' }} className="d-flex flex-wrap gap-2">
                            {_times?.length ? <> {(_times || [])?.map((s: any, ind: number) => (
                                <div key={ind} className='d-flex w-100'>
                                    <span className="rounded-pill badge bg-success-subtle text-success fs-13">
                                        {s?.time}
                                    </span>
                                    {!!s?.date ? <>
                                        <span className="text-primary mx-1">~</span>
                                        <span className="rounded-pill badge bg-primary-subtle text-primary fs-13">
                                            {s?.date}
                                        </span>
                                    </> : <>
                                        <span className="text-primary mx-1">~</span>
                                        <span className="rounded-pill badge bg-primary-subtle text-primary fs-13">
                                            {s?.schedule}
                                        </span></>}
                                </div>
                            ))}</> : <>-</>}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Auto Publication'),
                accessor: "is_auto_publish",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '140px' }} className="d-flex flex-column text-center gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex align-items-center justify-content-center">
                                    <span className={`rounded-pill badge bg-${_m?.is_auto_publish ? 'success' : 'danger'} fs-12 me-2`}>
                                        {_m?.is_auto_publish ? 'On' : 'Off'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            // {
            //     Header: t('Auto Publication'),
            //     accessor: "is_auto_publish",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 160,
            //     thClass: 'text-center align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '140px' }} className="text-center">
            //                 <span className={`rounded-pill badge bg-${item?.medias?.[0]?.is_auto_publish ? 'success' : 'danger'} fs-12`}>
            //                     {item?.medias?.[0]?.is_auto_publish ? 'On' : 'Off'}
            //                 </span>
            //             </div>
            //         </>)
            //     },
            // },
            // {
            //     Header: t('AI Model'),
            //     accessor: "ai_model",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 150,
            //     thClass: 'text-center align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         const _ai_model = AI_MODEL_OPTIONS_LANG?.find((_m: any) => (String(item?.campaign_gold_price?.ai_model) === String(_m?.value)));
            //         return (<>
            //             <div style={{ minWidth: '130px' }} className="text-center">
            //                 {_ai_model?.label || '-'}
            //             </div>
            //         </>)
            //     },
            // },
            // {
            //     Header: t('Prompt'),
            //     accessor: "prompt",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 320,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '300px', maxWidth: '350px' }} className="cursor-pointer hover-underline text-over-two-line" onClick={() => handleShowPrompt(item?.prompt)}>
            //                 {item?.prompt || '-'}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 150,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '120px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Generate Article')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className={`btn btn-sm btn-soft-primary edit-item-btn `} to="#"
                                            onClick={(e) => { e.preventDefault(); handleCreateNews(item) }}
                                        >
                                            {(idCampaignCreateNewsLoading === item?.id) ? <div style={{ transform: 'translateY(1px)' }}><Spinner size="sm" className="text-white" style={{ width: '12px', height: '12px' }}></Spinner></div> : <i className={`ri-restart-line align-bottom ${!!idCampaignCreateNewsLoading ? 'text-white' : ''}`}></i>}
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions) && <TooltipCustom
                                title={t('Button Update Campaign')}
                                id={`update-us-${item?.id}`}
                            >
                                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                                        onClick={(e) => { e.preventDefault(); handleSetCampaignDetail(item) }}
                                    >
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </Link>
                                </li>
                            </TooltipCustom>}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_DELETE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Button Delete Campaign')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                                        >
                                            <i className="ri-delete-bin-3-fill align-bottom"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, idLoading, idAutoPublishLoading, idCampaignCreateNewsLoading, JSON.stringify(query), JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            const [res1, res2, res3, res4, res5]: any = await Promise.all([getAllPartners({}), allSubjectVote({}), allBodyVote({}), allTemplateChart({}), allCategoryVote()]);
            const _list_partner = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
            const _list_subject = (res2?.data || [])?.map((sj: any, index: number) => ({ value: String(sj?.id), label: sj?.name }));
            const _list_body = (res3?.data || [])?.map((bd: any, index: number) => ({ value: String(bd?.id), label: bd?.name }));
            const _list_template_chart = (res4?.data || []);
            const _list_category_vote = (res5?.data || []);
            setPartners((_prev: any) => _list_partner);
            setTemplateSubject((_prev: any) => _list_subject);
            setTemplateBody((_prev: any) => _list_body);
            setTemplateChart((_prev: any) => _list_template_chart);
            setCategoryVote((_prev: any) => _list_category_vote);

            if (query?.media_id) {
                const _val = (_list_partner)?.find((s: any) => String(s?.value) === String(query?.media_id));
                setMediaSearch(_val);
            }

            if (query?.title_template_id) {
                const _val = (_list_subject)?.find((s: any) => String(s?.value) === String(query?.title_template_id));
                setTemplateSubjectSearch(_val);
            }

            if (query?.body_template_id) {
                const _val = (_list_body)?.find((s: any) => String(s?.value) === String(query?.body_template_id));
                setTemplateBodySearch(_val);
            }


        } catch (error: any) {
            return error;
        }
    };

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-5 col-sm-5">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isCampaignVoteLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={campaignVotes?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-7 col-sm-7 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_CREATE, userPermissions) && (<div className="col-sm-auto">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn rounded-pill"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        handleSetCampaignDetail({ time_request: + new Date() } as any)
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i>
                                                    {t('Button Create Campaign')}
                                                </button>
                                            </div>
                                        </div>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Name')} isShow={!!campaignNameSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Name')}...`}
                                                value={campaignNameSearch}
                                                onChange={(e) => setCampaignNameSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Category')} isShow={true}>
                                            <DropdownCategoryVote
                                                name="dc_trend_category_id"
                                                placeholder={t('Category')}
                                                isClearable={false}
                                                dataList={categoryVote}
                                                initialValue={categorySearch}
                                                onChangeCategory={(event) => {
                                                    setCategorySearch(event);
                                                }}
                                                className="dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Media')} isShow={true}>
                                            <DropdownOption
                                                name="media"
                                                dataList={filterMediaOptions(partners || [])}
                                                placeholder={`${t("Media")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={mediaSearch || null}
                                                onChangeSelect={(e: any) => setMediaSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Status')} isShow={true}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={STATUS_CAMPAIGN_OPTIONS_LANG || []}
                                                placeholder={`${t("Status")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={COLORS_STATUS_CAMPAIGN}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Subject Template')} isShow={true}>
                                            <DropdownOption
                                                name="template_subject"
                                                dataList={templateSubject || []}
                                                placeholder={`${t("Subject Template")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={templateSubjectSearch || null}
                                                onChangeSelect={(e: any) => setTemplateSubjectSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Body Template')} isShow={true}>
                                            <DropdownOption
                                                name="template_body"
                                                dataList={templateBody || []}
                                                placeholder={`${t("Body Template")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={templateBodySearch || null}
                                                onChangeSelect={(e: any) => setTemplateBodySearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Voting Target')} isShow={true}>
                                            <DropdownOption
                                                name="cycle_type"
                                                dataList={SCHEDULE_VOTE_OPTIONS_LANG || []}
                                                placeholder={`${t("Voting Target")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={cycleTypeSearch || null}
                                                onChangeSelect={(e: any) => setCycleTypeSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={8} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end mt-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isCampaignVoteLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card "
                                    tableClass="align-middle sticky-table-campaign-gold-price"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={campaignVotes?.list?.length ? campaignVotes?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={campaignVotes?.pagination?.total}
                                    customPageCount={Math.ceil(Number(campaignVotes?.pagination?.total) / Number(campaignVotes?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isCampaignVoteLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <Modal
                isOpen={!!isShowPrompt}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowPrompt(() => false)}
            >
                <ModalHeader toggle={() => setIsShowPrompt(() => false)}>
                    <>{t("Prompt")}</>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="fs-15" style={{ whiteSpace: 'break-spaces' }}>
                        {promptShow || ''}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowPrompt(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <CampaignForm
                isOpen={!!campaignDetail}
                detail={campaignDetail}
                sources={sources}
                partners={partners}
                templateSubject={templateSubject}
                templateBody={templateBody}
                categoryVote={categoryVote}
                // templateChart={templateChart}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
            />

            <ModalConfirm
                header={t('Button Delete Campaign')}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default CampaignList;